import { NeoReport, Report } from "@singularsystems/neo-reporting";
import { MaintenanceReportCategories } from "../MaintenanceReportCategories";
import React from "react";
import { Layout } from '@singularsystems/neo-canvas-grid';
import { Neo } from "@singularsystems/neo-react";
import ExchangeRatesForDayExtractReportCriteria from "./ExchangeRatesForDayExtractReportCriteria";
import { TextConstants } from "../../../Common/TextConstants";

@NeoReport("ExchangeRatesForDayExtract", { category: MaintenanceReportCategories.DataExtractReports})
export default class ExchangeRatesForDayExtractReport extends Report<ExchangeRatesForDayExtractReportCriteria> {

    constructor() {
        super(ExchangeRatesForDayExtractReportCriteria);
    }

    public renderCriteria() {
        return <React.Fragment>
            <Neo.GridLayout lg={4}>
                <Neo.FormGroup
                    appendText="fa-calendar"
                    bind={this.criteria.meta.reportingDate}
                    label={TextConstants.Labels.Date}
                    />
            </Neo.GridLayout>
        </React.Fragment>
    }

    public getDefaultGridLayout() {
        return {
            "root": {
            }
        } as Layout.IGridLayout;
    }
}